<script lang="ts" setup>
export interface SocialProps {
    data: SocialsItem[]
    size?: 'small' | 'large'
}

const props = withDefaults(defineProps<SocialProps>(), {
    size: 'large',
})

const { data: gaEventData, sendEvent } = useTracker()

const handleClick = (title: string, url: string): void => {
    sendEvent({
        data: {
            ...gaEventData,
            title: title,
            click: url,
        },
    })
}

// computed width and height of the social buttons
const size = computed<{
    width: number
    height: number
}>(() => {
    if (props.size === 'small')
        return {
            width: 23,
            height: 23,
        }

    return {
        width: 40,
        height: 40,
    }
})
</script>
<template>
  <a
    v-for="item in props.data"
    :key="`sbk-${item.title}`"
    :href="item.url"
    target="_blank"
    :data-cy="`social_link_${item.title}`"
    :aria-label="item.title"
    @click="handleClick(item.title, item.url)"
  >

    <img
      :src="item.icon.path"
      alt=""
      :width="size.width"
      :height="size.height"
      aria-hidden="true"
    >

  </a>
</template>
<style lang="scss" scoped>
@import './SocialButtons.scss';
</style>
